var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { jsx } from "react/jsx-runtime";
import * as React from "react";
import { Route, Link } from "react-router-dom";
import { WithCallout } from "../Callout/WithCallout.js";
import NavigationService from "@ane/core/lib/services/NavigationService";
import "../Icon/index.js";
import { Icon } from "../Icon/Icon.js";
class LinkRouteAction extends React.Component {
  render() {
    const { children, text, className, ariaLabel, callout, href, iconName, onClick } = this.props;
    const content = !!children ? children : text;
    return /* @__PURE__ */ jsx(
      Route,
      {
        render: (history) => {
          let updatedUrl = href;
          if (href) {
            updatedUrl = NavigationService.getCustomQueryParams(href, history.location.search);
          }
          let calloutProps = {
            ariaLabel: callout || "",
            calloutProps: { content: callout }
          };
          return /* @__PURE__ */ jsx(WithCallout, __spreadProps(__spreadValues({ preventAutoTabIndex: true }, calloutProps), { children: updatedUrl && /* @__PURE__ */ jsx(Link, { to: updatedUrl, onClick, className, "data-test-id": this.props.dataTestId, children: iconName ? /* @__PURE__ */ jsx(Icon, { ariaLabel, iconName, children: content }) : content }) }));
        }
      }
    );
  }
}
__publicField(LinkRouteAction, "defaultProps", {
  href: "#",
  ariaLabel: "",
  text: "Link"
});
class LinkRouteActionV2 extends React.Component {
  render() {
    const { children, text, className, ariaLabel, callout, href, iconName, dataTelemetryId, dataTestId, onClick, target } = this.props;
    const content = !!children ? children : text;
    const defaultAriaLabel = typeof content === "string" ? content : text;
    return /* @__PURE__ */ jsx(
      Route,
      {
        render: (history) => {
          let updatedUrl = href;
          if (href) {
            updatedUrl = NavigationService.getCustomQueryParams(NavigationService.getURLPathName(href), history.location.search);
          }
          let calloutProps = {
            ariaLabel: callout || "",
            calloutProps: { content: callout }
          };
          return /* @__PURE__ */ jsx(WithCallout, __spreadProps(__spreadValues({ preventAutoTabIndex: true }, calloutProps), { children: updatedUrl && /* @__PURE__ */ jsx(
            Link,
            {
              to: updatedUrl,
              onClick,
              className,
              "data-test-id": dataTestId,
              "aria-label": !!ariaLabel ? ariaLabel : defaultAriaLabel,
              "data-telemetry-id": dataTelemetryId,
              target,
              children: iconName ? /* @__PURE__ */ jsx(
                Icon,
                {
                  ariaLabel: !!ariaLabel ? ariaLabel : defaultAriaLabel,
                  iconName,
                  "data-telemetry-id": dataTelemetryId,
                  children: content
                }
              ) : content
            }
          ) }));
        }
      }
    );
  }
}
__publicField(LinkRouteActionV2, "defaultProps", {
  href: "#",
  ariaLabel: "",
  text: "Link"
});
export {
  LinkRouteAction,
  LinkRouteActionV2,
  LinkRouteAction as default
};
//# sourceMappingURL=LinkRouteAction.js.map
